import { useState } from 'react'
import {
  animeSchedule,
  articelsHomePageImages,
  footerImages,
  images,
} from '../services/images.service'
import { addEmailToMailingList } from '../services/mailingList.service'
import toast from 'react-hot-toast'
import { Link } from 'react-router-dom'
import {
  DiscordIcon,
  InstagramIcon,
  TelegramIcon,
  TiktokIcon,
  YoutubeIcon,
} from './ui/icons/shared'
import { GreyBorderBottom } from './ui/elements'

export function FooterMobile() {
  const [email, setEmail] = useState('')
  const [isChecked, setIsChecked] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!email.includes('@') || !email.includes('.')) {
      toast.error('נא להזין אימייל תקין.')
      return
    }

    if (!isChecked) {
      toast.error('נא לאשר קבלת עדכונים.')
      return
    }

    try {
      const response = await addEmailToMailingList(email)
      if (response.success) {
        toast.success(response.message)
        setEmail('')
        setIsChecked(false)
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      toast.error('שגיאה במהלך ההרשמה.')
      console.error(error)
    }
  }

  return (
    <div className="mx-12">
      <div className="flex flex-col justify-center items-center gap-8">
        <img src={images.logo} alt="AniZone logo" />
        <ul className="flex justify-center items-center gap-4">
          <li>
            <a
              href="https://www.tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <TiktokIcon />
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <YoutubeIcon />
            </a>
          </li>
          <li>
            <a
              href="http://t.me/anizoneil"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <TelegramIcon />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>
          </li>
          <li>
            <a
              href="https://discord.gg/uGpcw4ayCr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Discord"
            >
              <DiscordIcon />
            </a>
          </li>
        </ul>
      </div>

      <div className="my-14">
        <ul className="flex flex-col gap-7 text-softText text-lg">
          <li>מידע למתחיל</li>
          <li>מילון מושגים</li>
          <li>לוח שידורים</li>
          <li>המסע ליפן</li>
          <li>
            <Link to="/faq">שאלות ותשובות</Link>
          </li>
        </ul>
      </div>

      <div className="flex gap-10">
        <div className="text-softText">
          <div>
            <p className="text-lg">אנימות</p>
            <GreyBorderBottom className="w-full" />
          </div>
          <ul className="mt-6 flex flex-col gap-3">
            <li>דרגון בול זי</li>
            <li>וואן פיס</li>
            <li>נארוטו</li>
            <li>דרגון בול זי</li>
            <li>וואן פיס</li>
            <li>נארוטו</li>
            <li>דרגון בול זי</li>
            <li className="text-primary">לכל האנימות</li>
          </ul>
        </div>
        <div className="text-softText">
          <div>
            <p className="text-lg">קטגוריות</p>
            <GreyBorderBottom className="w-full" />
          </div>
          <ul className="mt-6 flex flex-col gap-3">
            <li>קטגוריה 1</li>
            <li>קטגוריה 2</li>
            <li>קטגוריה 3</li>
            <li>קטגוריה 4</li>
            <li>קטגוריה 5</li>
            <li>קטגוריה 6</li>
            <li>קטגוריה 7</li>
            <li className="text-primary">לכל הקטגוריות</li>
          </ul>
        </div>
      </div>

      <div className="mt-16">
        <div className="flex flex-col justify-center items-center w-[90%] text-center gap-2 mb-4">
          <img className="w-8" src={animeSchedule.mailIcon} alt="Mail Icon" />
          <h4 className="text-text">
            קבל עדכונים רלוונטים לאנימה בישראל, אירועים ועוד.
          </h4>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="relative">
            <input
              className="p-4 text-softText bg-[#424242] w-full rounded-md"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="אימייל"
              required
            />
            <button
              type="submit"
              className="absolute z-50 top-1/2 left-2 transform -translate-y-1/2"
            >
              <img src={footerImages.addmeBtn} alt="Add me" />
              <span className="absolute w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                צרפו אותי
              </span>
            </button>
          </div>
          <label className="flex gap-2 mt-2">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
            />
            <span className="text-softText text-lg">
              אני מאשר קבלת עדכונים מאניזון
            </span>
          </label>
        </form>
      </div>

      <div className="flex relative">
        <div className="text-softText flex flex-col justify-end absolute bottom-6">
          <ul className="flex flex-col gap-4">
            <Link to="/privacy-policy">
              <li>מדיניות הפרטיות</li>
            </Link>
            <span className="bg-[#464646] w-3 h-3 rounded-full"></span>
            <Link to="/accessibility-statement">
              <li>תנאי שימוש</li>
            </Link>
            <span className="bg-[#464646] w-3 h-3 rounded-full"></span>
            <Link to="/terms-of-use">
              <li>הצהרת נגישות</li>
            </Link>
          </ul>
        </div>

        <img
          className="w-[95%] mr-14 mt-2"
          src={footerImages.characterMain}
          alt="Character"
        />
      </div>
    </div>
  )
}
